<template>
  <div id="app">
    <Home />
  </div>
</template>

<script>
import Home from "@/templates/Index.vue"

export default {
  name: 'App',
  components: {
    Home,
  },
}
</script>
<style lang="scss">
  @import "styles/main"
</style>
